export default () => ({
  messages: []
})
